import React, { Component } from 'react';
import moment from 'moment';
import { Row, Col, Input, Divider, Tooltip, Button, Icon } from 'antd';
import { VIEWS } from '../../../utils/yourAccountUtils';

const questions = [
    'In what city were you born?',
    'What is your favorite food?',
    'What is your favorite color?'
];

class DataEntry extends Component {
    constructor(props) { super(props); }

    render() {
        const { question, service, value, name } = this.props;
        return (
            <Col span={7}>
                <Row type='flex' justify='space-around' align='middle'>
                    <Col span={24} style={{ lineHeight: '16px' }}>
                        <span style={{ fontWeight: 'bold', fontStyle: 'italic', fontSize: '11px' }}>
                            {question}
                        </span>
                    </Col>
                </Row>
                <Row type='flex' justify='space-around' align='middle'>
                    <Col span={24} style={{ lineHeight: '30px' }}>
                        <Input size='small' value={value} onChange={service} name={name} />
                    </Col>
                </Row>
            </Col>
        );
    }
}

export default class ChangeSecurityQuestions extends Component {
    state = {
        hasUpdated: false,
        hasFailed: false,
        lastUpdated: ''
    }

    constructor(props) { super(); }

    handleSave() {
        const
        p = this.props,
        { services } = p,
        { jti } = window.session;

        let answers = [
            { securityQuestionId: 1, securityQuestionAnswer: p.securityQuestion1 },
            { securityQuestionId: 2, securityQuestionAnswer: p.securityQuestion2 },
            { securityQuestionId: 3, securityQuestionAnswer: p.securityQuestion3 }
        ];

        if(p.securityQuestion1.length <= 0) answers[0] = null;
        if(p.securityQuestion2.length <= 0) answers[1] = null;
        if(p.securityQuestion3.length <= 0) answers[2] = null;
        answers = answers.filter(d => d);

        services.updateSecurityQuestionAnswers(jti, {
            updatedSecurityQuestionAnswers: answers
        });
    }

    updateIndicator(prev) {
        const
        { resetSecurityQuestionsRequest } = this.props.services,
        prevRequestStatus = prev.requests.updateSecurityQuestions.status,
        currRequestStatus = this.props.requests.updateSecurityQuestions.status;

        if(prevRequestStatus === 'pending' && currRequestStatus != null && currRequestStatus !== 'pending') {
            let timestamp = (
                <div style={{ fontSize: '9px', marginTop: '4px' }}>
                    <span style={{ fontStyle: 'italic' }}>
                        {`Last Updated: ${moment({}).format('YYYY-MM-DD HH:mm:ss')}`}
                    </span>
                </div>
            );

            resetSecurityQuestionsRequest();
            switch(currRequestStatus) {
                case 'success':
                    this.setState({
                        hasUpdated: true,
                        hasFailed: false,
                        lastUpdated: timestamp
                    });
                    break;
                case 'failure':
                    this.setState({
                        hasUpdated: false,
                        hasFailed: true,
                        lastUpdated: timestamp
                    });
                    break;
            }
        }
    }

    componentDidUpdate(prev) {
        this.updateIndicator(prev);
    }

    render() {
        const
        p = this.props,
        { updateDataEntry, changeView } = p.services,
        { hasUpdated, hasFailed, lastUpdated } = this.state,
        inputProps = { size: 'small' };

        let updateIndicator = null;

        if(hasUpdated && !hasFailed) updateIndicator = (
            <div className='ya-sq-indicator-div'>
                <span className='ya-sec-q-indicator-span'>
                    <Icon type='check-circle-o' />
                    {' Update Successful'}
                </span>
                {this.state.lastUpdated}
            </div>
        );
        else if(!hasUpdated && hasFailed) updateIndicator = (
            <div className='ya-sq-indicator-div'>
                <span className='ya-sec-q-indicator-span'>
                    <Icon type='close-circle-o' />
                    {' Update Failed'}
                </span>
                {this.state.lastUpdated}
            </div>
        );

        return (
            <div>
                {updateIndicator}
                <div style={{ position: 'absolute', top: '68px', right: '10px' }}>
                    <Tooltip placement='left' title='Update security questions.'>
                        <Button
                            size='small'
                            icon='save'
                            type='primary'
                            onClick={() => this.handleSave()}
                            style={{ width: '74px', borderRadius: '20px' }}
                            disabled={
                                p.securityQuestion1.trim().length > 0 &&
                                p.securityQuestion2.trim().length > 0 &&
                                p.securityQuestion3.trim().length > 0
                                    ? false : true
                            }
                        >
                            {'Save'}
                        </Button>
                    </Tooltip>
                </div>
                <div style={{ position: 'absolute', top: '68px', left: '10px' }}>
                    <Tooltip placement='right' title='Close security questions.'>
                        <Button
                            icon='arrow-left'
                            shape='circle'
                            onClick={() => changeView(VIEWS.YOUR_ACCOUNT, [
                                { field: 'securityQuestion1', value: '' },
                                { field: 'securityQuestion2', value: '' },
                                { field: 'securityQuestion3', value: '' }
                            ])}
                        />
                    </Tooltip>
                </div>
                <Row type='flex' justify='space-around' align='middle'>
                    <Col span={p.noIcon ? 16 : 23}>
                        <span style={{ lineHeight: '16px', fontStyle: 'italic' }}>{
                            'FTSP will not be able to supply these answers if you forget them. If you forget your ' +
                            'login information and no longer have access to the email address on file, you can now ' +
                            'change your email address online after correctly answering the security questions.'
                        }</span>
                    </Col>
                </Row>
                <Divider type='horizontal' style={{ margin: '10px 0px' }} />
                <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '30px' }}>
                    <Col span={23} style={{ textAlign: 'left' }}>
                        <span style={{ fontStyle: 'italic', fontWeight: 'bold' }}>
                            <Icon type='warning' />
                            {' Choose answers that you can easily remember.'}
                        </span>
                    </Col>
                </Row>
                <Row type='flex' justify='space-around' align='middle'>
                    <DataEntry question={questions[0]} service={updateDataEntry} value={p.securityQuestion1} name='securityQuestion1' />
                    <DataEntry question={questions[1]} service={updateDataEntry} value={p.securityQuestion2} name='securityQuestion2' />
                    <DataEntry question={questions[2]} service={updateDataEntry} value={p.securityQuestion3} name='securityQuestion3' />
                </Row>
            </div>
        )
    }
}
